export default [
    {
        title: "Indian Wear",
        links: [
            {
                href: "https://www.nykaafashion.com/indian/blouse.html?root=nav_2&ptype=listing",
                text: "Blouse",
            },
            { href: "https://www.nykaafashion.com/kurtis/c/4396", text: "Kurtis" },
            {
                href:
                    "https://www.nykaafashion.com/indian/salwar-suits-and-sets.html?root=nav_2&ptype=listing",
                text: "Salwar Suits and Sets",
            },
            {
                href: "https://www.nykaafashion.com/indian/lehengas.html?root=nav_2&ptype=listing",
                text: "Lehengas",
            },
            {
                href: "https://www.nykaafashion.com/indian/sarees.html?root=nav_2&ptype=listing",
                text: "Sarees",
            },
            {
                href:
                    "https://www.nykaafashion.com/indian/shawls-stoles-and-dupattas.html?root=nav_2&ptype=listing",
                text: "Shawls stoles & dupattas",
            },
            {
                href: "https://www.nykaafashion.com/indian/palazzos.html?root=nav_2&ptype=listing",
                text: "Palazzos",
            },
            {
                href:
                    "https://www.nykaafashion.com/indian.html?root=nav_2&ptype=listing&product_list_order=low-to-high",
                text: "Affordable Designer Ethnic Wear",
            },
        ],
    },
    {
        title: "Western Wear",
        links: [
            {
                href:
                    "https://www.nykaafashion.com/westernwear/dresses.html?root=nav_2&ptype=listing",
                text: "Dresses",
            },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/shirts-tops-and-crop-tops.html?root=nav_2&ptype=listing",
                text: "Shirts Tops and Crop Tops",
            },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/bottoms-pants-and-trousers.html?root=nav_2&ptype=listing",
                text: "Bottoms Pants and Trousers",
            },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/jumpsuits.html?root=nav_2&ptype=listing",
                text: "Jumpsuits",
            },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/skirts.html?root=nav_2&ptype=listing",
                text: "Skirts",
            },
            {
                href:
                    "https://www.nykaafashion.com/indian.html?root=nav_2&ptype=listing&product_list_order=low-to-high",
                text: "Affordable Designer Western Wear",
            },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/coats.html?root=nav_2&ptype=listing",
                text: "Coats",
            },
            { href: "https://www.nykaafashion.com/clothing/westernwear/gowns.html", text: "Gowns" },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/jackets.html?root=nav_2&ptype=listing",
                text: "Jackets",
            },
            {
                href:
                    "https://www.nykaafashion.com/westernwear/sweatshirts.html?root=nav_2&ptype=listing",
                text: "Sweatshirts",
            },
            {
                href: "https://www.nykaafashion.com/clothing/westernwear/tunics.html",
                text: "tunics",
            },
        ],
    },
    {
        title: "Accessories",
        links: [
            {
                href:
                    "https://www.nykaafashion.com/accessories/footwear.html?root=nav_3&ptype=listing",
                text: "Footwear",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/bags/handbags.html?root=nav_3&ptype=listing",
                text: "Handbags",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/bags/wallets.html?root=nav_3&ptype=listing",
                text: "Wallets",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/bags/backpacks.html?root=nav_3&ptype=listing",
                text: "Backpacks",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/footwear/sports-shoes-sneakers/c/3928?root=nav_3&ptype=listing",
                text: "Sneakers",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/footwear/sports-shoes-sneakers/c/3928?root=nav_3&ptype=listing",
                text: "Sport Shoes",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/footwear/boots.html?root=nav_3&ptype=listing",
                text: "Boots",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/footwear/sandals.html?root=nav_3&ptype=listing",
                text: "Sandals",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/bags/sling-and-cross-bags.html?root=nav_3&ptype=listing",
                text: "Sling Bags",
            },
        ],
    },
    {
        title: "lingerie",
        links: [
            {
                href: "https://www.nykaafashion.com/lingerie/bra/c/3947?root=nav_3&ptype=listing",
                text: "Bra",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/underwear/bikini/c/3977?root=nav_3&ptype=listing",
                text: "Bikini",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/activewear/leggings-pants/c/4017?root=nav_3&ptype=listing",
                text: "Leggings",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/shapewear/body-shapers/c/4000?root=nav_3&ptype=listing",
                text: "Body Shaper",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/sleep-lounge/loungewear/c/3997?root=nav_3&ptype=listing",
                text: "Loungewear",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/activewear/sports-bra/c/4016?root=nav_3&ptype=listing",
                text: "Sports Bra",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/bra/push-up/c/3954?root=nav_3&ptype=listing",
                text: "Push Up Bra",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/bra/padded/c/3951?root=nav_3&ptype=listing",
                text: "Padded Bra",
            },
            {
                href:
                    "https://www.nykaafashion.com/lingerie/bra/strapless/c/3956?root=nav_3&ptype=listing",
                text: "Strapless Bra",
            },
        ],
    },
    {
        title: "Jewellery",
        links: [
            {
                href: "https://www.nykaafashion.com/accessories/jewellery/earrings.html?root=nav_3&ptype=listing",
                text: "Earrings",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/necklaces-and-chokers.html?root=nav_3&ptype=listing",
                text: "Necklace",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/rings.html?root=nav_13&ptype=listing",
                text: "Rings",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/bangle-bracelets-and-cuffs.html?root=nav_23&ptype=listing",
                text: "Bracelet",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/bangle-bracelets-and-cuffs.html?root=nav_3&ptype=listing",
                text: "Bangles",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/nath.html?root=nav_3&ptype=cat_listing",
                text: "Nath",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/anklets/c/666?root=nav_3&ptype=listing,jewellery,categories,1,anklets",
                text: "Anklet",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/necklaces-and-chokers.html?root=nav_3&ptype=listing",
                text: "Choker",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/necklaces-and-chokers.html?root=nav_3&ptype=listing",
                text: "Cuff",
            },
            {
                href:
                    "https://www.nykaafashion.com/accessories/jewellery/maang-tikkas.html?root=nav_3&ptype=listing",
                text: "Maang Tikkas",
            },
        ],
    },
    {
        title: "Top Brands",
        links: [
            {
                href: "https://www.nykaafashion.com/designers/masaba.html?root=nav_2&ptype=listing",
                text: "Masaba",
            },
            {
                href: "https://www.nykaafashion.com/designers/mellowdrama.html",
                text: "MellowDrama",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/label-ritu-kumar.html?root=nav_2&ptype=listing",
                text: "Label Ritu Kumar",
            },
            {
                href: "https://www.nykaafashion.com/designers/and.html?root=nav_2&ptype=listing",
                text: "AND",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/global-desi.html?root=nav_2&ptype=listing",
                text: "Global Desi",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/ritu-kumar.html?root=nav_2ptype=cat_listing",
                text: "Ritu Kumar",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/fabnest.html?root=nav_2&ptype=listing",
                text: "Fabnest",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/ambraee.html?root=nav_2&ptype=listing",
                text: "Ambraee",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/desi-weavess.html?root=nav_2&ptype=listing",
                text: "Desi Weavess",
            },
            {
                href:
                    "https://www.nykaafashion.com/designers/desi-weavess.html?root=nav_2&ptype=listing",
                text: "Alaya by Stage3",
            },
        ],
    },
];
